import { Box } from '@mui/material';
import Logo from '../../components/Login/Logo';
import ResetPasswordEmailComponent from '../../components/ResetPassword/ResetPasswordEmail';

function ResetPasswordEmail() {
  return (
    <Box className='auth-page'>
      <Box className='center'>
        <Box className='body'>
          <Logo />
          <Box className='login-title-block' mt={2}>
            <Box className='login'>RESET PASSWORD</Box>
          </Box>
          <ResetPasswordEmailComponent />
        </Box>
      </Box>
    </Box>
  );
}

export default ResetPasswordEmail;
